export default "__VITE_ASSET__10bd51e0__$_?nuxt_component=async__"